"use client";
import { useFormContext } from "react-hook-form";
import { SUBSCRIPTION_CONTRACT_META_KEY } from "@cappelendamm/e-commerce-services";
import { CheckoutForm } from "@/checkout/types";
import { FormCard } from "@/forms/FormCard";
import { FormGroup } from "@/forms/FormGroup";
import { InputField } from "@/forms/InputField";
import { ChildBirthDateFields } from "./ChildBirthDateFields";
import { Typography } from "@cappelendamm/design-system/react";

export type ChildInformationSectionProps = {
  isPending?: boolean;
  isChildClubSubscription?: boolean;
};

export const ChildInformationSection = ({
  isPending = false,
  isChildClubSubscription = false,
}: ChildInformationSectionProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CheckoutForm>();

  if (!isChildClubSubscription) {
    return null;
  }

  return (
    <FormCard>
      <FormGroup isDisabled={isPending}>
        <Typography as="legend" variant="title-md" className="mb-2">
          Om barnet
        </Typography>

        <InputField
          name={`meta.${SUBSCRIPTION_CONTRACT_META_KEY.CHILD_NAME}`}
          label="Barnets navn"
          register={register}
          error={errors.meta?.[SUBSCRIPTION_CONTRACT_META_KEY.CHILD_NAME]}
          disabled={isPending}
        />

        <ChildBirthDateFields isPending={isPending} />
      </FormGroup>
    </FormCard>
  );
};
